import ClientEdit, { ClientEditTrigger } from './ClientEdit'
import * as constants from './constants'
import * as actions from './actions'

export default ClientEdit
export { ClientEditTrigger, constants, actions }
